"use client";
import * as React from "react";
import { useState } from "react";
import type { ToggleConnectionStatusProps } from "../types";
import defaultClasses from "./index.module.css";
import cssClassAssembler from "../../utils/cssClassAssembler";
import ToggleSwitch from "../../../shared/ToggleSwitch/index";
import ConfirmationPrompt from "../../../shared/ConfirmationPrompt/index";
import { sendHTTPRequest } from "../../../shared/http";

function ToggleConnectionStatus(props: ToggleConnectionStatusProps) {
  const [displayPrompt, setDisplayPrompt] = useState(() => false);

  function connectionStatus() {
    return props.connection.deactivated ? "Inactive" : "Active";
  }

  function connectionAction() {
    return props.connection.deactivated ? "activate" : "deactivate";
  }

  function askForConfirmation() {
    setDisplayPrompt(true);
  }

  function onCancel() {
    setDisplayPrompt(false);
  }

  function onConfirm() {
    updateConnectionStatus(!props.connection.deactivated);
  }

  function classes() {
    return {
      container: cssClassAssembler(
        props.classNames?.container,
        defaultClasses.container
      ),
    };
  }

  function updateConnectionStatus(status: boolean) {
    async function updateConnection() {
      type payload = {
        [key: string]: string | boolean;
      };
      const body: payload = {
        clientID: props.connection.clientID,
        clientSecret: props.connection.clientSecret,
        tenant: props.connection.tenant,
        product: props.connection.product,
        deactivated: status,
      };
      const connectionIsSAML = "idpMetadata" in props.connection ? true : false;
      const connectionIsOIDC =
        "oidcProvider" in props.connection ? true : false;
      if (connectionIsSAML) {
        body["isSAML"] = true;
      } else if (connectionIsOIDC) {
        body["isOIDC"] = true;
      }
      const data = await sendHTTPRequest<undefined>(props.urls.patch, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      setDisplayPrompt(false);
      if (data?.error) {
        typeof props.errorCallback === "function" &&
          props.errorCallback(data.error.message);
      } else {
        typeof props.successCallback === "function" &&
          props.successCallback({
            operation: "UPDATE",
            connectionIsSAML,
            connectionIsOIDC,
          });
      }
    }
    updateConnection();
  }

  return (
    <>
      {props.connection !== undefined || props.connection !== null ? (
        <>
          <div className={classes().container}>
            {displayPrompt ? (
              <ConfirmationPrompt
                ctoaVariant={
                  props.connection.deactivated ? "primary" : "destructive"
                }
                classNames={props.classNames?.confirmationPrompt}
                cancelCallback={onCancel}
                confirmationCallback={onConfirm}
                promptMessage={`Do you want to ${connectionAction()} the connection?`}
              />
            ) : null}
            {!displayPrompt ? (
              <ToggleSwitch
                label={connectionStatus()}
                handleChange={askForConfirmation}
                checked={!props.connection.deactivated}
                disabled={displayPrompt}
              />
            ) : null}
          </div>
        </>
      ) : null}
    </>
  );
}

export default ToggleConnectionStatus;
